<script type="text/javascript">
	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";
	import moment from "moment";
	import axios from "axios";

	import MenuItem from "../FlyoutMenu/MenuItem.svelte";

	import '../LayerList/LayerList.scss';
	import LayerListSwitch from '../LayerList/LayerListSwitch.svelte';
	import MaritimeFeatureSwitch from './MaritimeFeatureSwitch.svelte';
	import Spinner from "../Spinner/Spinner.svelte";
	import Button, {Label, Group, GroupItem, Icon as ButtonIcon} from '@smui/button';
	import Card from '@smui/card';

	import AppStore from "../../AppStore";
	import MapStore from "../../Map/Store";
	import MapControlType from "../../Map/Enums/MapControlType";
	import { Layout, Paint } from "../../Map/MapLayerStyles";

	import IdentityHelper from "../../Branding/IdentityHelper";
	import User from "../../Branding/User";
	import Feature from "../../Branding/Feature";
	import LoadState from "../../Enums/LoadState";

	import GeoHelper from "../../Helpers/GeoHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import FilterHelper from "../../Helpers/FilterHelper";
	import ValidationHelper from "../../Helpers/ValidationHelper";
	import InputHelper from "../../Helpers/InputHelper";

	import MapLayer from "../../Map/Enums/MapLayer";
	import MapViewType from "../../Map/Enums/MapViewType";
	import MapDataSource from "../../Map/Enums/MapDataSource";
	import MapLayerManager from "../../Map/MapLayerManager";

	import API from "../../API/API";

	import MaritimeFeaturesStore from "./Store";


	let error = MaritimeFeaturesStore.meta.error;
	let initState = MaritimeFeaturesStore.meta.initState;
	let loadState = MaritimeFeaturesStore.meta.loadState;

	onMount(()=>{
		MaritimeFeaturesStore.actions.init();
		return () => {
			MaritimeFeaturesStore.actions.deinitMap();
		};
	});

	$: {
		$initState;
		$loadState;
		$error;
	}

	let requestBboxReadable = MaritimeFeaturesStore.inputs.bbox.readable;
	let responseLength = MaritimeFeaturesStore.results.length;
	let responseMultiPage = MaritimeFeaturesStore.results.multipage;
	let onStartDraw = () => {
		AppStore.snackbar.start("Draw a rectangle to set.", "success");

		let prev = get(MapStore.control);
		MapStore.controlData.boxPicker.visible.set(true);
		MapStore.control.set(MapControlType.BOX_PICKER);
		const unsubscribe = MapStore.controlData.boxPicker.obj.end.subscribe((end)=>{
			if (get(MapStore.controlData.boxPicker.obj.dragging)) {
				MapStore.controlData.boxPicker.obj.roundTo.set(1);
				const bbox = MapStore.controlData.boxPicker.obj.getBBox();
				// set.setBounds(bbox[0], bbox[1]);

				const topLeft = bbox[0];
				const bottomRight = bbox[1];
				let _tl = topLeft;
				let _br = bottomRight;
				let _extent = [_tl[0], _br[0], _tl[1], _br[1]];
				let _rectCoords = MapStore.helpers.generateRectCoordsFromExtent(_extent);
				let _newBbox = [..._rectCoords, _rectCoords[0]];
				let resultOutline = GeoHelper.featureLineString(_newBbox);

				console.log("_newBbox", _newBbox);
				MaritimeFeaturesStore.inputs.bbox.readable.set(bbox);
				MaritimeFeaturesStore.inputs.bbox.value.set(_newBbox);

				const map = MapStore.helpers.getMap();
				map.getSource("ukho_features_outlines").setData(GeoHelper.emptyGeoJson([resultOutline]));

				console.log("bbox", bbox);
				console.log("_newBbox", _newBbox);
				MapStore.control.set(prev);
				MapStore.controlData.boxPicker.visible.set(false);
				//set.lastUpdated.set(Date.now());
				//ShippingLanesStore.update();
				unsubscribe();
			}
		});
	};

	let attributeCodes = MaritimeFeaturesStore.meta.codes.attributeCodes;

</script>

<MenuItem title={"Query Maritime Features"} materialIcon={"layers"}>
	{#if $initState !== LoadState.LOADED}
		<p>Loading...</p>
	{:else}
		<h2>Area (bounding box):</h2>
		{#if $requestBboxReadable === null}
			<p><a href="/" on:click|preventDefault={onStartDraw}>Draw bounding box</a></p>
		{:else}
			{#if $loadState === LoadState.INIT}
				<p><span>{$requestBboxReadable}</span> (<a href="/" on:click|preventDefault={onStartDraw}>redraw</a>)</p>
			{:else}
				<p><span>{$requestBboxReadable}</span></p>
			{/if}
		{/if}

		<h2>Features:</h2>
		{#each Object.keys(MaritimeFeaturesStore.inputs.toggles) as key}
			<MaritimeFeatureSwitch
				label={MaritimeFeaturesStore.inputs.toggles[key].name}
				disabled={$loadState !== LoadState.INIT}
				checked={MaritimeFeaturesStore.inputs.toggles[key].enabled}
				/>
			{#each MaritimeFeaturesStore.inputs.toggles[key].attributeFilters as filter}
				<div class='layer-list-item indent-2'>
					<span>{$attributeCodes[filter].description}:</span>
					<select
						bind:value={MaritimeFeaturesStore.inputs.toggles[key].attributeFilterValues[filter]}
						style='width:100%;'
						disabled={$loadState !== LoadState.INIT}
						>
						<option value="" selected="true">All</option>
						{#each $attributeCodes[filter].known_attribute_values as attrValue}
							<option value={attrValue}>{attrValue}</option>
						{/each}
					</select>
				</div>
			{/each}
		{/each}


		<Button 
			on:click={MaritimeFeaturesStore.actions.submit} 
			color="secondary" 
			variant="unelevated" 
			id="vessels-nearby-submit" 
			style="width:100%;margin-top:10px;" 
			disabled={$loadState !== LoadState.INIT || $requestBboxReadable === null}
			><Label>Fetch data</Label></Button>

		{#if $loadState === LoadState.LOADED}
			<Button id="vessel-history-reset"
					title="Reset"
					class='bg-error'
					color="secondary"
					variant="unelevated"
					style="width:100%;margin-top:5px;"
					on:click={MaritimeFeaturesStore.actions.reset}>
				<Label>Reset</Label>
			</Button>
		{/if}

		{#if $error.length > 0 && $loadState === LoadState.INIT}
			<Card class="bg-error" padded style="margin-top:10px;">
				<p style="font-weight:bold;">{$error}</p>
			</Card>
		{/if}

	{/if}
</MenuItem>

{#if $loadState === LoadState.LOADED}
	<MenuItem title={"Results"} materialIcon={"layers"}>

		<p>{$responseLength} total results.</p>

		{#if $responseMultiPage}
			<div class="msgbox bg-warning mt-10"><p>Results contains multiple pages and this is not yet supported. Please narrow your search criteria.</p></div>
		{/if}

		{#each MaritimeFeaturesStore.helpers.getResponseToggleKeys() as key}
			<p><strong>{MaritimeFeaturesStore.inputs.toggles[key].name}</strong></p>
			<MaritimeFeatureSwitch
				label={"Visible"}
				disabled={false}
				checked={MaritimeFeaturesStore.inputs.toggles[key].visible}
				on:change={()=>{
					console.log("changed");
					MaritimeFeaturesStore.actions.updateMap()
				}}
				/>
		{/each}
	</MenuItem>
{/if}

<MenuItem>
	<p class='data-attribution' style='margin-bottom:7px;'>Provided by:</p>
	<img src='/img/logo-admiralty.png' alt="Data provided by Admiralty" style="width:30%;display:block;"/>
</MenuItem>
